import {
  GET_CARRIERS_LIST_IN_PROGRESS,
  GET_CARRIERS_LIST_SUCCESS,
  GET_CARRIERS_LIST_FAIL,
} from "../constants";
import { LOGOUT } from "../../authentication/constants";

const initialState = {
  list: [],
  inProgress: false,
  error: false,
};

/**
 * Carriers reducer
 *
 * @param {Object} state
 * @param {Object} action
 *
 * @return {Object}
 */
export default function carriers(state = initialState, action) {
  const { payload, type } = action;

  switch (type) {
    case GET_CARRIERS_LIST_IN_PROGRESS:
      return {
        ...state,
        inProgress: true,
        error: false,
      };

    case GET_CARRIERS_LIST_SUCCESS:
      return {
        ...state,
        list: payload.list,
        inProgress: false,
      };

    case GET_CARRIERS_LIST_FAIL:
      return {
        ...state,
        inProgress: false,
        error: true,
      };

    case LOGOUT:
      return {
        ...state,
        ...initialState,
      };

    default:
      return state;
  }
}
